/**
* @name: emptyImg
* @author: weiyong
* @date: 2024-10-13 09:30
* @description：emptyImg
* @update: 2024-10-13 09:30
*/
<template>
  <div class="ant-upload-list-item-info w100b xm-empty-img">
      <span class="ant-upload-span w100b flex-wrap">
        <div class="ant-upload-list-item-thumbnail ant-upload-list-item-file">
          <span role="img" aria-label="picture" class="anticon anticon-picture">
            <svg  focusable="false" class="" data-icon="picture" width="1em" height="1em" fill="currentColor" aria-hidden="true" viewBox="64 64 896 896"><path d="M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z" fill="#1890ff"></path><path d="M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z" fill="#e6f7ff"></path><path d="M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 110 176 88 88 0 010-176z" fill="#e6f7ff"></path><path d="M276 368a28 28 0 1056 0 28 28 0 10-56 0z" fill="#888"></path><path d="M304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z" fill="#888"></path>
            </svg>
          </span>
        </div>
        <div class="w100b ant-upload-list-item-name" title="image.png">无附件</div><!----></span>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "emptyImg",
});
</script>

<script lang="ts" setup>

</script>

<style type="text/css" lang="less">
.xm-empty-img{
  min-width:100px;
  width: 100px;
  .ant-upload-span{
    border: 1px solid #eee;
    display: flex;
    align-items: center;
    justify-content: center;
    padding:12px;
  }
  .ant-upload-list-item-name{
    padding-left: 0;
    text-align: center;
    color:#777;
  }
  .ant-upload-list-item-thumbnail{

    svg{
      color:#888;
      font-size:30px;
    }
  }
}

</style>
